module.exports = __webpack_public_path__ + "images/charity5.bf1f366f.svg";